import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const PrivateRoute = ({ children }) => {
    const { accessToken, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>;
    }

    return accessToken ? children : <Navigate to="/auth" replace />;

};

export default PrivateRoute;
